<template>
  <div :class="componentClasses" @click="clicked()">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 37.5C75 16.8232 58.1768 0 37.5 0C16.8232 0 0 16.8232 0 37.5C0 48.4214 4.69636 58.2655 12.1718 65.1245L12.1364 65.1559L13.3527 66.1814C13.4318 66.2482 13.5177 66.3027 13.5968 66.3682C14.2432 66.9041 14.9127 67.4127 15.5945 67.905C15.8155 68.0645 16.0364 68.2241 16.2614 68.3795C16.9895 68.8814 17.7368 69.3573 18.5005 69.8086C18.6668 69.9068 18.8345 70.0023 19.0023 70.0977C19.8382 70.5736 20.6918 71.0223 21.5659 71.4341C21.63 71.4641 21.6955 71.4914 21.7595 71.5214C24.6082 72.8455 27.6491 73.8177 30.8291 74.3918C30.9123 74.4068 30.9955 74.4218 31.08 74.4368C32.0673 74.6073 33.0655 74.7436 34.0759 74.835C34.1986 74.8459 34.3214 74.8527 34.4455 74.8636C35.4518 74.9468 36.4691 75 37.5 75C38.5214 75 39.5291 74.9468 40.53 74.8664C40.6568 74.8555 40.7836 74.8486 40.9105 74.8377C41.9127 74.7464 42.9027 74.6141 43.8805 74.4464C43.965 74.4314 44.0509 74.4164 44.1355 74.4C47.2677 73.8382 50.265 72.8877 53.0768 71.5977C53.1805 71.55 53.2855 71.505 53.3891 71.4559C54.2305 71.0605 55.0527 70.6336 55.8586 70.1795C56.0591 70.0664 56.2582 69.9518 56.4573 69.8345C57.1909 69.4023 57.9123 68.9509 58.6132 68.4709C58.8655 68.2991 59.1123 68.1177 59.3618 67.9377C59.9605 67.5068 60.5482 67.0623 61.1195 66.5973C61.2464 66.495 61.3827 66.4064 61.5068 66.3014L62.7545 65.2595L62.7177 65.2282C70.2586 58.3664 75 48.4773 75 37.5ZM2.72727 37.5C2.72727 18.3259 18.3259 2.72727 37.5 2.72727C56.6741 2.72727 72.2727 18.3259 72.2727 37.5C72.2727 47.8323 67.7386 57.1214 60.5605 63.495C60.1595 63.2182 59.7559 62.97 59.3427 62.7627L47.7968 56.9905C46.7605 56.4723 46.1168 55.4305 46.1168 54.2727V50.2405C46.3841 49.9105 46.6664 49.5368 46.9582 49.1264C48.4527 47.0155 49.6514 44.6673 50.5255 42.1405C52.2532 41.3195 53.3686 39.5986 53.3686 37.6555V32.8214C53.3686 31.6391 52.935 30.4923 52.1591 29.5909V23.2268C52.23 22.5177 52.4809 18.525 49.5914 15.2305C47.0782 12.3614 43.0105 10.9091 37.5 10.9091C31.9895 10.9091 27.9218 12.3614 25.4086 15.2291C22.5191 18.5236 22.77 22.5191 22.8409 23.2255V29.5895C22.0664 30.4909 21.6314 31.6377 21.6314 32.82V37.6541C21.6314 39.1555 22.305 40.5559 23.4586 41.5009C24.5632 45.8277 26.8364 49.1032 27.6764 50.2132V54.1595C27.6764 55.2723 27.0695 56.295 26.0918 56.8295L15.3095 62.7109C14.9659 62.8977 14.625 63.1159 14.2841 63.36C7.19455 56.9891 2.72727 47.7573 2.72727 37.5Z"
        fill="#E5E5E5"
      />
    </svg>
  </div>
</template>

<script>
import iconMixin from '../../../mixins/component-mixins/root/iconMixin'

export default {
  name: 'IconProfile',
  mixins: [iconMixin],
  computed: {
    componentClasses: function () {
      return {
        'rc-icon': true,
        'rc-icon-profile': true,
        ...this.componentSizeClasses,
        ...this.componentStateClasses
      }
    }
  }
}
</script>

<style scoped></style>
